import {
  ApiABExperiment,
  ApiABExperimentBucketForId,
  ApiABExperimentId,
} from 'api/types/ApiABExperiment';
import { postJson } from 'utils/http';

export async function setABExperimentBucket<
  TExperimentId extends ApiABExperimentId
>(
  experimentId: TExperimentId,
  bucket?: ApiABExperimentBucketForId<TExperimentId>
): Promise<ApiABExperiment<TExperimentId>[]> {
  const { abExperiments } = await postJson<{
    abExperiments: ApiABExperiment<TExperimentId>[];
  }>('/data/ab/assignments', { id: experimentId, bucket });

  return abExperiments;
}
